module.exports = __webpack_public_path__ + "static/media/ready_to_start_image.003e04d4.png";